import { useEffect } from 'react';

/**
 * Custom hook to automatically stop voice dictation during loading states
 * and other interrupting events
 */
export const useVoiceDictationInterruption = (
    voiceRecordingRef: React.RefObject<any>,
    resetVoiceState: () => void,
    dependencies: {
        isLoading?: boolean;
        isFetching?: boolean;
        isSaving?: boolean;
        isCreating?: boolean;
        templateChanged?: boolean;
        contentChanged?: boolean;
        [key: string]: any;
    }
) => {
    useEffect(() => {
        const {
            isLoading,
            isFetching,
            isSaving,
            isCreating,
            templateChanged,
            contentChanged,
            ...otherDeps
        } = dependencies;

        // Check if any interrupting state is active
        const shouldStopDictation =
            isLoading ||
            isFetching ||
            isSaving ||
            isCreating ||
            templateChanged ||
            contentChanged ||
            Object.values(otherDeps).some(dep => Boolean(dep));

        if (shouldStopDictation) {
            console.log('Voice dictation interrupted due to state change:', {
                isLoading,
                isFetching,
                isSaving,
                isCreating,
                templateChanged,
                contentChanged,
                otherDeps
            });

            voiceRecordingRef.current?.stopListening();
            resetVoiceState();
        }
    }, Object.values(dependencies));

    // Stop dictation when component unmounts or major state changes
    useEffect(() => {
        return () => {
            voiceRecordingRef.current?.stopListening();
            resetVoiceState();
        };
    }, [voiceRecordingRef, resetVoiceState]);
};
